import { Retailer } from '@/core/entity';
import { IRetailerGateway, PresenterFunc, UpdaterFunc } from '@/core/interface';

export class RemoveRetailer {
  constructor(
    private readonly retailerGateway: IRetailerGateway,
  ) { }

  public async execute(
    id: string,
    presenter: PresenterFunc<Retailer | null>,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      const result = await this.retailerGateway.removeRetailer(id, undefined, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}
